export const update_money_transfer = `subscription update_money_transfer{
    update_money_transfer{
        transaction_code
        status
        from_account
        currency{
            currency
            name
            decimal
        }
        amount
        order_date
    }
}`;
